import ky from 'ky-universal';
import useSWR from 'swr';

export const fetcher = async (url, options): Promise<any> => {
  const response = await ky(url, { throwHttpErrors: false, ...options });

  if (!response.ok) {
    return Promise.reject(await response.json());
  }

  return response.json();
};

type SWRUrl = string | Array<string> | (() => string);
type SWRResponse = { data?: any; error?: any };

const SWROptions = { revalidateOnFocus: false };

const useCustomSWR = (url: SWRUrl): SWRResponse =>
  useSWR(url, fetcher, SWROptions);

export default useCustomSWR;
